import React from 'react'
import { Col, Row, Dropdown, Form, Container } from 'react-bootstrap'
import { IoIosSearch as SearchIcon } from 'react-icons/io'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { i18nTranslate } from 'src/utils'

import './styles.scss'

@observer
class DualDropDownWithSeachBar extends React.Component {
  @observable
  searchValues = {}

  @observable
  currentlySelectedType = ''

  handleChange = (event, item) => {
    event.preventDefault()
    const { onSubmit } = this.props
    const { name, type } = item
    this.searchValues = {}
    this.currentlySelectedType = name
    if (type === 'select') {
      this.searchValues[name] = event?.target?.value
    } else if (type === 'search') {
      this.searchValues[name] = event?.currentTarget?.[0]?.value
    }
    const attributes = {
      ...this.searchValues,
      currentlySelectedType: this.currentlySelectedType,
    }
    onSubmit(attributes)
  }

  handleChangeData = event => {
    const searchValue = event?.currentTarget?.[0]?.value
    this.props.handleChangeData(searchValue)
  }

  renderSearchView = (searchFormInput, index) => {
    const {
      customClassName = '',
      columnType = '',
      placeHolderText,
      defaultValue,
    } = searchFormInput
    const className = `search-bar-wrapper ${customClassName}`
    return (
      <Col {...columnType} className={className} key={index}>
        <Form
          className={`team-search-bar position-relative ${this.props.searchBarClassName}`}
          onSubmit={event => {
            this.handleChange(event, searchFormInput)
          }}>
          <Form.Control
            type="text"
            placeholder={placeHolderText}
            data-testid="qa-search-input"
            onChange={event => {
              this.handleChangeData(event, searchFormInput)
            }}
            value={defaultValue}
            aria-label={i18nTranslate(
              'input.searchInput',
              'search input textbox',
              {
                nameSpace: 'ssr-resource',
              }
            )}
          />
          <div className="search-icon-wrapper">
            <SearchIcon
              className="search-icon"
              data-testid="qa-search-icon"
              aria-label={i18nTranslate('icons.searchicon', 'search icon', {
                nameSpace: 'ssr-resource',
              })}
            />
          </div>
        </Form>
      </Col>
    )
  }

  renderMenuItem = (item, index, dropDownInput) => {
    return (
      <Dropdown.Item
        as="button"
        className="text-capitalize text-wrap"
        onClick={event => {
          this.handleChange(event, dropDownInput)
        }}
        key={index}
        value={item.value}
        data-testid="qa-dropdown-lists">
        {item.label}
      </Dropdown.Item>
    )
  }

  renderDropDownView = (dropDownInput, index) => {
    const {
      customClassName = '',
      columnType = {},
      label,
      options = [],
      defaultValue,
    } = dropDownInput

    const className = `search-dropdown-wrapper  mt-2 mt-md-0 mt-lg-0 ${customClassName}`
    return (
      <Col {...columnType} className={`${className}`} key={index}>
        <label className="team-search-form-label text-capitalize w-100">
          {label}
        </label>
        <Dropdown className="team-search-box">
          <Dropdown.Toggle
            className="team-search-toggle pb-1 w-100 d-flex align-items-center justify-content-between"
            variant="">
            <span className="team-search-dropdown-text text-capitalize">
              {defaultValue}
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu className="w-100">
            {options &&
              options.map((item, index) => {
                return this.renderMenuItem(item, index, dropDownInput)
              })}
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    )
  }
  filterView = (input, index) => {
    if (input.type === 'select') {
      return this.renderDropDownView(input, index)
    } else if (input.type === 'search') {
      return this.renderSearchView(input, index)
    }
  }

  render() {
    const { title = 'Title', filterInput } = this.props
    const filterView = filterInput.map(this.filterView)
    return (
      <Container className="p-0">
        <Row noGutters className="bg-white dual-dropdown-wrapper mb-2">
          <Col className="filter-wrap">
            <h4 className="mb-0" data-testid="qa-filter-heading">
              {title}
            </h4>
            <Row
              noGutters
              className="team-search-form-container justify-content-between p-0 mt-4 d-flex align-items-end search-filter-wrapper"
              data-testid="qa-filter-form">
              {filterView}
            </Row>
          </Col>
        </Row>
      </Container>
    )
  }
}

export { DualDropDownWithSeachBar }
export default DualDropDownWithSeachBar
